import classNames from 'classnames';
import Favorite from 'components/icons/Favorite';
import React, { useState } from 'react';

export type FavoriteButtonBaseProps = {
  isSaved: boolean;
  isLogged: boolean;
  onClick: (e: React.MouseEvent) => void;
  full?: boolean;
  visibility?: string;
  className?: string;
  iconWidth?: number;
  iconHeight?: number;
  desktopIconWidth?: number;
  desktopIconHeight?: number;
  labelClassName?: string;
  darkGold?: boolean;
  gapClassName?: string;
};

const FavoriteButtonBase: React.FC<FavoriteButtonBaseProps> = ({
  isSaved,
  isLogged,
  onClick,
  full,
  visibility = 'hidden',
  className,
  iconWidth,
  iconHeight,
  desktopIconWidth,
  desktopIconHeight,
  labelClassName,
  darkGold,
  gapClassName,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <button
      type="button"
      aria-label={isSaved ? 'Delete from Favorites' : 'Save to Favorites'}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={classNames(
        'cursor-pointer group block',
        full &&
          `flex items-center uppercase md:w-full h-7 xl:min-w-[70px] ${
            gapClassName || ''
          }`,
        className
      )}
    >
      {/* flex-shrink-0: the longer "Saved" label otherwise squeezes the icon */}
      <span className="inline-flex flex-shrink-0">
        <Favorite
          fill={isSaved && isLogged}
          white={!full}
          hover={hovered}
          width={iconWidth}
          height={iconHeight}
          desktopWidth={desktopIconWidth}
          desktopHeight={desktopIconHeight}
          darkGold={darkGold}
        />
      </span>
      {full && (
        <span
          className={classNames(
            `${visibility} ${
              gapClassName ? '' : 'px-2'
            } pt-px hover-animation md:block`,
            labelClassName || 'text-14-18-0.3 md:text-16-21-0.3',
            {
              'text-gold-hover': hovered,
            }
          )}
        >
          {isSaved ? 'Saved' : 'Save'}
        </span>
      )}
    </button>
  );
};

export default FavoriteButtonBase;
